var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('distributor-map',{ref:"map",attrs:{"settings":_vm.settings,"items":_vm.items,"geography":_vm.$options.countriesData,"displayField":_vm.displayField}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }